import { AxiosResponse } from 'axios'
import { MaterialsListInterface } from 'store/SalesOrderContext/types/MaterialItemData'
import { SalesOrderData } from 'store/SalesOrderContext/types/SalesOrderData'
import api from 'services/api'
import { filterSimulation, messagePlanilhaToast } from './utils'
import {
  RequestBodyMaintainDraft,
  RequestBodyCancelDraft,
  RequestBodyConfirmDraft,
  RequestBodyFinishOV,
  RequestParamsGetDraftById,
  RequestBodySimulateDraft,
  RequestParamsGetDeliveryClients,
  QueryParamsListDraftItem,
  RequestParamsGetPaymentTermsById,
  RequestParamsDeleteDraftOv,
  RequestParamsDuplicateDraft,
  RequestParamsGetListPaymentTerms,
  SpreadsheetMaterial,
  RequestParamsInsertItemMaterialOv,
  RequestParamsEditItemMaterialOv,
  RequestGetLastHeader,
  RequestBodyMaintainItem,
  RequestBodyDeleteItem,
  RequestInventoryTotalizer,
  RequestInventoryMaterials,
  ResponseInventoryTotalizer,
  ResponseInventoryMaterials
} from './interfaces'
import { toast } from 'react-toastify'

export interface DuplicaResponse {
  NumeroPedido: string
  CodigoCliente: string
  MensagemRetorno: string
  OperacaoRealizada: boolean
}

export interface InsertAndEditMaterialOvItemResponse {
  NumeroItemOrdemVenda: number
  Mensagem: string
  OperacaoRealizada: boolean
  NegociacaoDiferenciada: boolean
}

export const postCancelDraft = async (body: RequestBodyCancelDraft) => {
  const returnApi = await api
    .post(`rascunho/CancelaRascunho`, { ...body })
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}

export const postConfirmDraft = async (body: RequestBodyConfirmDraft) => {
  const returnApi = await api
    .post(`/order/v2/Confirmacao`, { ...body })
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}
export const getLastHeader = async ({
  numeroPedido,
  codigoCliente,
  preparacaoMto
}: RequestGetLastHeader) => {
  const returnApi = await api
    .get(
      `rascunho/v2/${numeroPedido}/obter-ultimo-cabecalho?codigoSapCliente=${codigoCliente}&preparacaoMto=${preparacaoMto}`
    )
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}

export const postFinishOV = async (body: RequestBodyFinishOV) => {
  const returnApi = await api
    .post(`rascunho/v2/FinalizaOV`, { ...body })
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}

export const postSimulateDraft = async (body: RequestBodySimulateDraft) => {
  const returnApi = await api
    .post(`/order/v2/Solicitacao`, { ...body })
    .then((response) => response)
    .then((data) => {
      const simulation = data.data
      if (simulation && simulation.materiais.length) {
        return filterSimulation(simulation)
      }
      return simulation
    })
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}

export const getDraftById = async (params: RequestParamsGetDraftById) => {
  try {
    const returnApi: AxiosResponse<SalesOrderData> = await api.get(
      `rascunho/v2/GetRascunhoById?nr_pedi_rasc=${params.nr_pedi_rasc}`
    )
    return returnApi.data
  } catch (e) {
    toast.error('Erro ao carregar rascunho')
  }
}

export const getInventoryTotalizer = async (payload: RequestInventoryTotalizer) => {
  const response: AxiosResponse<ResponseInventoryTotalizer> = await api.post(
    `rascunho/v2/estoque-livre/totalizadores`,
    payload
  )

  return response.data
}

export const getInventoryReport = async () => {
  const response: AxiosResponse<ArrayBuffer> = await api.get(
    'rascunho/v2/estoque-livre/relatorio',
    { responseType: 'arraybuffer' }
  )

  return response.data
}

export const getInventoryMaterials = async (payload: RequestInventoryMaterials) => {
  const response: AxiosResponse<ResponseInventoryMaterials> = await api.post(
    `rascunho/v2/estoque-livre/materias`,
    payload
  )

  return response.data
}

export const getDeliveryClients = async (params: RequestParamsGetDeliveryClients) => {
  const { cd_empr, cd_orgn_vend, cd_canl_dstb, cd_seto_atvd, cd_clie } = params
  const returnApi = await api
    .get(
      `cliente/v2/ListClienteEntrega?cd_empr=${cd_empr}&cd_orgn_vend=${cd_orgn_vend}&cd_canl_dstb=${cd_canl_dstb}&cd_seto_atvd=${cd_seto_atvd}&cd_clie=${cd_clie}`
    )
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}

export const postMaintainDraft = async (
  body: RequestBodyMaintainDraft,
  query?: Record<string, string>
) => {
  const returnApi = await api
    .post(
      `rascunho/v2/MaintainRascunho`,
      { ...body },
      {
        params: query
      }
    )
    .then((data) => data.data)
    .catch((e) => {
      throw new Error(e?.response?.data?.return_chav)
    })
  return returnApi
}
export const postMaintainItem = async (body: RequestBodyMaintainItem) => {
  const returnApi = await api
    .post(`rascunho/v2/MaintainItemRascunho`, { ...body })
    .then((data) => data.data)
    .catch((e) => {
      throw new Error(e?.response?.data?.return_chav)
    })
  return returnApi
}
export const deleteItemRascunho = async (body: RequestBodyDeleteItem) => {
  const returnApi = await api
    .delete(`rascunho/v2/DeleteItemRascunho`, { data: body })
    .then((data) => data.data)
    .catch((e) => {
      throw new Error(e?.response?.data?.return_chav)
    })
  return returnApi
}
interface QueryParamsList extends QueryParamsListDraftItem {
  matr?: string
}

export const getListDraftItem = async (
  query: QueryParamsList
): Promise<MaterialsListInterface[]> => {
  const returnApi = await api
    .get(`rascunho/v2/ListRascunhoItem`, {
      params: query
    })
    .then((response) => response)
    .then((data) => data.data as MaterialsListInterface[])
    .catch(() => toast.error('Erro ao carregar lista'))
  return returnApi as MaterialsListInterface[]
}

export const getPaymentTermsById = async (params: RequestParamsGetPaymentTermsById) => {
  const {
    cd_empr,
    cd_canl_dstb,
    cd_cond_pgto,
    cd_orgn_vend,
    cd_tipo_orde,
    fl_orde_tele_vend
  } = params
  const returnApi = await api
    .get(
      `politica-comercial/CondicaoPagamentoById?cd_empr=${cd_empr}&cd_orgn_vend=${cd_orgn_vend}&cd_canl_dstb=${cd_canl_dstb}&cd_tipo_orde=${cd_tipo_orde}&fl_orde_tele_vend=${fl_orde_tele_vend}&cd_cond_pgto=${cd_cond_pgto}`
    )
    .then((response) => response)
    .then((data) => data.data)
    .catch(() => toast.error('Erro ao carregar termos de pagamento!'))
  return returnApi
}

export const getPaymentsTerms = async (params: RequestParamsGetListPaymentTerms) => {
  const {
    qt_rowcount,
    cd_empr,
    cd_orgn_vend,
    cd_canl_dstb,
    cd_tipo_orde,
    fl_orde_tele_vend,
    cd_cond_pgto
  } = params
  const returnApi = await api
    .get(
      `politica-comercial/ListCondicaoPagamento?qt_rowcount=${qt_rowcount}&cd_empr=${cd_empr}&cd_orgn_vend=${cd_orgn_vend}&cd_canl_dstb=${cd_canl_dstb}&cd_tipo_orde=${cd_tipo_orde}&fl_orde_tele_vend=${fl_orde_tele_vend}&cd_cond_pgto=${cd_cond_pgto}`
    )
    .then((data) => data.data)
    .catch((err) => console.error(err))
  return returnApi
}

export const deleteDraftOV = async (params: RequestParamsDeleteDraftOv) => {
  const res = await api
    .delete(`rascunho/v2/DeleteRascunho`, { data: params })
    .then((response) => response)
    .then((data) => {
      return data.data
    })
    .catch(() => {
      toast.error('Erro ao deletar!')
    })

  return res
}

export const duplicateDraftOV = async (
  params: RequestParamsDuplicateDraft
): Promise<DuplicaResponse[]> => {
  const res = await api
    .post(`rascunho/v2/DuplicaRascunho`, params)
    .then((response) => response)
    .then((data) => {
      return data.data
    })
    .catch(() => {
      toast.error('Erro ao duplicar!')
    })

  return res
}

export const uploadSheetDraft = async (
  paramsUpload: FormData,
  paramsMaintainRascunho: RequestBodyMaintainDraft,
  setProgress?: (progress: number) => void
) => {
  let uploadedMaterials
  if (
    (paramsUpload.get(`file`) as File).type ===
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ) {
    uploadedMaterials = await api
      .post(`rascunho/v2/upload-planilha`, paramsUpload, {
        headers: {
          'Content-Type':
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        onUploadProgress(progressEvent) {
          const percentCompleted = progressEvent.total
            ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
            : 0
          if (setProgress) setProgress(percentCompleted)
        }
      })
      .then((response) => response.data)
      .catch((error) => {
        toast.error(messagePlanilhaToast(error.response.data.MensagemRetorno))
      })
  } else {
    uploadedMaterials = await api
      .post(`upload-order/file-upload`, paramsUpload, {
        headers: { 'Content-Type': 'application/vnd.ms-excel' },
        onUploadProgress(progressEvent) {
          const percentCompleted = progressEvent.total
            ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
            : 0
          if (setProgress) setProgress(percentCompleted)
        }
      })
      .then((response) => response)
      .then((data) => {
        return data.data
      })
      .catch(() => {
        toast.error('Erro ao carregar planilha!')
      })
  }

  if (!uploadedMaterials) {
    return
  } else {
    if (uploadedMaterials.NumeroPedidoRascunho) {
      return uploadedMaterials
    } else {
      const ds_item_pedi_rasc = uploadedMaterials.map((material: SpreadsheetMaterial) => {
        return { ...material, pc_dsct: paramsMaintainRascunho.pc_dsct }
      })

      const res = await postMaintainDraft(
        {
          ...paramsMaintainRascunho,
          ds_item_pedi_rasc,
          fl_uplo_plan: 'S'
        },
        { InsertMaterialsByUpload: 'true' }
      )

      return res
    }
  }
}

export const insertItemMaterialOv = async (
  ovNumber: string,
  params: RequestParamsInsertItemMaterialOv
): Promise<InsertAndEditMaterialOvItemResponse> => {
  const res = await api
    .post(`/gerir-ov/${ovNumber}/inserir-item`, params)
    .then((response) => response)
    .then((data) => {
      return data.data
    })
    .catch(() => {
      toast.error('Erro ao inserir item!')
    })
  return res
}

export const EdittemMaterialOv = async (
  ovNumber: string,
  params: RequestParamsEditItemMaterialOv
): Promise<InsertAndEditMaterialOvItemResponse> => {
  const res = await api
    .post(`/gerir-ov/${ovNumber}/editar-item`, params)
    .then((response) => response)
    .then((data) => {
      return data.data
    })
    .catch(() => {
      toast.error('Erro ao editar item!')
    })

  return res
}
